export const apiRoutes = {
  api_r_user_module_intelligence_home: {
    path: 'm/intelligence/home/',
  },
  api_r_user_m_intelligence_calculateReport: {
    path: 'm/intelligence/calculate-report/',
  },
  api_r_user_m_intelligence_crudProfile: {
    path: 'm/intelligence/crud-profile/',
  },
  api_r_user_module_intelligence_savedReports: {
    path: 'm/intelligence/saved-reports/',
  },
  api_r_user_module_intelligence_getSavedReport: {
    path: 'm/intelligence/get-saved-report/',
  },
  api_r_user_module_intelligence_deleteSavedReport: {
    path: 'm/intelligence/delete-saved-report/',
  },
  api_r_user_module_intelligence_getReportOptions: {
    path: 'm/intelligence/get-report-options/',
  },
  api_r_user_module_intelligence_changeComment:
  {
    path: 'm/intelligence/change-comment/',
  },
};
